export const rateLimitT = {
  en: {
    title: 'Account temporarily blocked',
    description:
      'We detected too many requests from your account, so the security system has temporarily restricted access. If this is a mistake, contact support and we’ll quickly restore your access.',
    support: 'Contact support',
    retry: 'Try again',
  },
  ru: {
    title: 'Аккаунт временно заблокирован',
    description:
      'Мы зафиксировали слишком много запросов с вашего аккаунта, и система безопасности временно ограничила доступ. Если это ошибка — напишите в поддержку, и мы быстро вернём доступ.',
    support: 'Написать в поддержку',
    retry: 'Попробовать снова',
  },
}
